// ============================================================
// Hirafi — Module devis : persistence localStorage (mode invité)
// ============================================================

import type { StandaloneDevisFormData } from "../types";

const KEY = "hirafi_guest_devis";

/** Sauvegarde le brouillon invité dans localStorage */
export function saveGuestDraft(data: StandaloneDevisFormData): void {
  try {
    localStorage.setItem(KEY, JSON.stringify(data));
  } catch {
    // localStorage peut être indisponible (navigation privée saturée)
  }
}

/** Charge le brouillon invité depuis localStorage (SEC-007 : validation structure minimale) */
export function loadGuestDraft(): StandaloneDevisFormData | null {
  try {
    const raw = localStorage.getItem(KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    // Validation structure minimale : doit avoir artisan, client, title, lineItems
    if (
      typeof parsed !== "object" ||
      parsed === null ||
      typeof parsed.artisan !== "object" ||
      typeof parsed.client !== "object" ||
      !Array.isArray(parsed.lineItems)
    ) {
      return null;
    }
    return parsed as StandaloneDevisFormData;
  } catch {
    return null;
  }
}

/** Supprime le brouillon invité */
export function clearGuestDraft(): void {
  try {
    localStorage.removeItem(KEY);
  } catch {
    // silencieux
  }
}

/** Retourne true si un brouillon invité existe */
export function hasGuestDraft(): boolean {
  try {
    return localStorage.getItem(KEY) !== null;
  } catch {
    return false;
  }
}
